import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { parse } from 'qs';

import { useIsMountedRef } from '@/hooks/useIsMountedRef';
import { Subscription } from '@/types/subscriptions/subscription';
import { useAppSelector } from '@/store';
import { authStore } from '@/store/auth';
import { subscriptionRequestsApi } from '@/services/api';
import { useApiErrorHandler } from '@/hooks/useApiErrorHandler';

import { SubscriptionListRoot } from '../Presentation';

type Props = {
  serviceGroupID: number;
};

export const SubscriptionListRootContainer: React.FC<Props> = ({
  serviceGroupID,
}) => {
  const { apiErrorHandler } = useApiErrorHandler();
  const organizationId = useAppSelector(
    authStore.selectors.organizationIdSelector,
  );
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const isMountedRef = useIsMountedRef();

  const location = useLocation();
  const orderBy = parse(location.search, { ignoreQueryPrefix: true })
    .order_by as string;

  useEffect(() => {
    (async () => {
      if (isMountedRef.current) {
        setIsLoading(true);
      }
      try {
        const subscriptions = await subscriptionRequestsApi.getList({
          data: {
            organizationId,
          },
          params: {
            service_group_id: serviceGroupID,
            order_by: orderBy,
            per_page: 999,
          },
        });
        if (isMountedRef.current) {
          setSubscriptions(subscriptions);
        }
      } catch (err) {
        apiErrorHandler(err);
      }
      if (isMountedRef.current) {
        setIsLoading(false);
      }
    })();
  }, [
    serviceGroupID,
    location,
    isMountedRef,
    organizationId,
    orderBy,
    apiErrorHandler,
  ]);

  const childProps = {
    subscriptions,
    isLoading,
  };
  return <SubscriptionListRoot {...childProps} />;
};
